import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterFieldValue } from '../covance-filter.models';
import { CovanceFilterBaseType } from './covance-filter-base-type';
import { isEmpty, includes } from 'lodash';

@Injectable()
export class CovanceFilterTextType extends CovanceFilterBaseType {
    constructor(router: Router, route: ActivatedRoute) {
        super(router, route);
    }

    public serializeValue(filterValue: any): string {
        return filterValue;
    }

    public isMatch(fieldVal: FilterFieldValue, value: any) {
        if (isEmpty(value)) {
            return false;
        }

        return includes(value.toLowerCase(), fieldVal.value.toLowerCase());
    }
}